import { Switch } from "antd";
import moment from "moment";

export const releaseDocumentsColumns = (navigate, handleSwitchToggle, switchStates = {}) => [
  {
    title: "Document Name",
    dataIndex: "documentName",
    key: "documentName",
    width: 150,
    // sorter: {
    //   compare: (a, b) => a.documentName.localeCompare(b.documentName),
    // },
  },
  // {
  //   title: "Type",
  //   dataIndex: "type",
  //   key: "type",
  //   width: 135,
  //   align: "center",
  // },
  {
    title: "Last updated",
    dataIndex: "modifiedAt",
    key: "modifiedAt",
    width: 135,
    // sorter: {
    //   compare: (a, b) => {
    //     const dateA = moment(a.lastUpdated, "YYYY-MM-DD");
    //     const dateB = moment(b.lastUpdated, "YYYY-MM-DD");
    //     return dateA - dateB;
    //   },
    // },
    render: (date) => {
      if (date) {
        return moment(date).format("YYYY-MM-DD");
      }
      return "-";
    },
  },
  {
    title: "Current Version",
    dataIndex: "currentVersion",
    key: "currentVersion",
    width: 135,
    align: "center",
    render: (version) => {
      return <div className="text-center">{`V.${version}`}</div>;
    },
  },
  {
    title: "Status",
    key: "status",
    width: 135,
    align: "center",
    dataIndex: "status",
    render: (_, record) => (
      <Switch
        className="switches"
        checked={
          record.status && (typeof record.status === 'string' ? record.status.toUpperCase() === 'ACTIVE' : !!record.status)
        }
        onChange={(checked) => handleSwitchToggle(record, checked)}
      />
    ),
  },
  {
    title: "Action",
    key: "action",
    width: 135,
    align: "center",
    render: (_, record) => (
      <button
        className="manage"
        onClick={() =>
          navigate("/manage-release-document", {
            state: { documentData: record },
          })
        }
      >
        Manage
      </button>
    ),
  },
];

